import { EndpointSetting } from "@/constants/app/type";
import { FlightState } from "../type";

const mapListFareRules = (listFareRules: unknown): Record<string, any> => {
  if (Array.isArray(listFareRules)) {
    return listFareRules.reduce((obj1: any, fareRuleItem: any) => {
      const ruleNumber = String(fareRuleItem?.ruleNumber || "")
        .toUpperCase()
        .split(/\s+/)
        .join("")
      if (ruleNumber) {
        obj1[ruleNumber] = fareRuleItem
      }
      return obj1
    }, {})
  }

  if (listFareRules && typeof listFareRules === "object") {
    return listFareRules as Record<string, any>
  }

  return {}
}

export const callbackFareRules: EndpointSetting['caller'] = (
  state: FlightState,
  action: any,
  endpointName: 'get_fare_rules_0' | 'get_fare_rules_1'
) => {
  state[endpointName].loading = false
  state[endpointName].error = null
  state[endpointName].success = true
  state[endpointName].called = true

  const payload = Array.isArray(action.payload) ? action.payload : []

  for (let i = 0; i < payload.length; i++) {
    const fareRule = payload[i]
    if (!fareRule?.airline) continue

    state[endpointName].data[fareRule.airline] = {
      ...fareRule,
      listFareRules: mapListFareRules(fareRule.listFareRules),
    }
  }
}